import * as sharedEnvironmentalLabelsSpecifications from '../../common/vehicleSpecifications/environmentalLabels.js'

// Define only the vehicle specifications that are different from the common ones
export const ENVIRONMENTAL_LABELS = {...sharedEnvironmentalLabelsSpecifications.ENVIRONMENTAL_LABELS}
export const ENVIRONMENTAL_LABELS_IDS = {...sharedEnvironmentalLabelsSpecifications.ENVIRONMENTAL_LABELS_IDS}
